import { SupplierInformationDto } from "../../../autogen/bff-api";
import type { AnnouncementAttachment } from "../../documents/utils";

export type PublishedDocument = AnnouncementAttachment;

export const collectPublishedDocuments = (
  eventId: string,
  announcements: SupplierInformationDto[],
  existingDocumentIds: Iterable<string>,
): PublishedDocument[] => {
  const excluded = new Set(existingDocumentIds);
  const seen = new Set<string>();
  const documents: PublishedDocument[] = [];
  for (const announcement of announcements) {
    for (const attachment of announcement.attachments ?? []) {
      const id = attachment.documentId;
      if (excluded.has(id) || seen.has(id)) continue;
      seen.add(id);
      documents.push({
        kind: "announcementAttachment",
        id,
        eventId,
        name: attachment.fileName,
        publishedAt: announcement.createdAt,
      });
    }
  }
  return documents;
};
